import { UPLOADS_URL } from '../api/axios';
import React, { useEffect, useState } from 'react';
import API from '../api/axios';
import SEO from '../components/SEO';
import Reveal from '../components/ui/Reveal';

const CDN = 'https://www.cambridgeschooljjr.com/wp-content/uploads';

import { API_URL } from '../api/axios';
const UPLOADS_BASE = API_URL;

const FALLBACK_BRANCHES = [
  { name: 'Vasundhara', image: `${CDN}/2024/04/Vasundhara-sec-16-photo-495x400.jpg`, link: 'https://Cambridgevasundhara.com/' },
  { name: 'Bhadana', image: `${CDN}/2024/08/WhatsApp-Image-2024-08-08-at-2.40.01-PM-1-495x400.jpeg`, link: 'https://www.cambridgeschooljjr.com/' },
  { name: 'Bhadana', image: `${CDN}/2025/11/IMG-20221109-WA0067-495x400.jpg`, link: 'https://www.cambridgeschooljjr.com/' },
  { name: 'Dehradun', image: `${CDN}/2025/11/IMG-20221109-WA0068-495x400.jpg`, link: 'https://www.Cambridgedehradun.in/' },
  { name: 'Gurugram', image: `${CDN}/2024/12/gurgram-495x400.jpg`, link: 'https://www.Cambridgegurugram.com/' },
  { name: 'Sonipat', image: `${CDN}/2024/12/sonipat-495x400.jpg`, link: 'https://www.Cambridgesonipat.com/' },
];

const resolveImg = (src) => {
  if (!src) return src;
  if (src.startsWith('/frontend/')) return src.replace('/frontend/', '/');
  if (src.startsWith('http') || src.startsWith('/')) return src;
  return `${UPLOADS_BASE}/uploads/${src}`;
};

const OtherBranches = () => {
  const [branchSec, setBranchSec] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/home-sections').then((res) => {
      const d = res.data?.data;
      if (d?.branches?.items?.length) setBranchSec(d.branches);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const kicker = branchSec?.kicker || 'Other Branches';
  const heading = branchSec?.heading || 'Explore Our Schools';
  const branches = (branchSec?.items?.length ? branchSec.items : FALLBACK_BRANCHES).map((b) => ({
    ...b,
    img: resolveImg(b.image || b.img),
  }));

  return (
    <>
      <SEO title={heading} description={`${heading} — Cambridge International Sr. Sec. School network across India.`} keywords="Other Branches, Cambridge International Sr. Sec. School" />

      <section className="page-hero">
        {!loading && (
          <img src={`${process.env.PUBLIC_URL}/images/page-banners/why-choose-us.jpg`} alt={heading} className="page-hero-img" loading="eager" />
        )}
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner">
            </div>
          </div>
        </div>
      </section>

      <section className="section bg-gray-50">
        <div className="container">
          <div className="section-title mb-12">
            <div className="kicker">{kicker}</div>
            <h2 className="h-section text-3xl md:text-4xl font-bold">{heading}</h2>
            <div className="divider-line" />
          </div>

          <div className="max-w-[1200px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {branches.map((branch, i) => (
              <Reveal key={branch.name} delayMs={i * 70}>
                <div className="group rounded-xl overflow-hidden bg-white shadow-sm border border-gray-100 hover:shadow-xl transition-all">
                  <div className="relative overflow-hidden">
                    <img src={branch.img} alt={branch.name} className="w-full h-auto object-contain transition-transform duration-700 group-hover:scale-110" loading="lazy" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  </div>
                  <div className="p-5">
                    <h3 className="text-primary text-lg font-semibold mb-3">{branch.name}</h3>
                    <a href={branch.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-secondary font-semibold text-sm hover:text-primary transition-colors">
                      Read More <i className="fas fa-arrow-right text-[11px]"></i>
                    </a>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default OtherBranches;